import { makeAutoObservable } from 'mobx'
import type RouterStore from 'features/main/main-router/org-guard/RouterStore'
import type AnnouncementStore from '../AnnouncementStore'
import { newMeetingHandoffPath } from 'features/meetings/newMeetingHandoff'

interface AnnouncementWorkitemDeprecationStoreProps {
   routerStore: RouterStore
   announcementStore: AnnouncementStore
}

export default class AnnouncementWorkitemDeprecationStore {
   sp: AnnouncementWorkitemDeprecationStoreProps

   constructor(sp: AnnouncementWorkitemDeprecationStoreProps) {
      this.sp = sp
      makeAutoObservable(this)
   }

   /** Hides the banner for good and hands off to a new Blank Meeting with the template picker open. */
   tryMeetingsWorkspace = () => {
      this.sp.announcementStore.dismissAnnouncement('workitemDeprecation')()
      this.sp.routerStore.navigate(newMeetingHandoffPath('work-items-banner'))
   }
}
